<h2>Sign In</h2>
<form class="needs-validation" novalidate>
  <div class=" mb-3 " style="position:relative;">
    <input (blur)="typeEmail()" (keydown.enter)="displayPassword()" [(ngModel)]="userEmail" [ngClass]="{'is-invalid':statusText1}" [ngModelOptions]="{standalone: true}"
           class="form-control" id="username"
           placeholder="yourname@email.com" required style="padding-right:42px;" type="text">

    <div [hidden]="!statusText1" class="invalid-feedback d-block shift-invalid-login"
         id="statusText1">{{statusText1}}
    </div>
    <div [hidden]="!errorEmail" class="invalid-feedback d-block shift-invalid-login"
         id="errorEmail">{{errorEmail}}
    </div>
  </div>

  <div *ngIf="showPassword" class="form-group">
    <input #pwd (blur)="typePassword()" [(ngModel)]="userPwd" [ngClass]="{'is-invalid':statusText2}" [ngModelOptions]="{standalone: true}"
           class="form-control mt-3" id="password"
           placeholder="password" required type="password">
  </div>
  <button (click)="displayPassword()" *ngIf="!showPassword" class="btn btn-orange mt-4 btn-block">Continue</button>
  <button (click)="submitLogin()" *ngIf="showPassword" class="btn btn-orange mt-4 btn-block">Login</button>
  <div *ngIf="showPassword" class="forgot">
    <a routerLink="/access/forgotPassword">Forgot Password ?</a>
  </div>
  <div *ngIf="!showPassword" class="mt-100 mb-1">New to FleetConnect?</div>
  <div *ngIf="showPassword" class="mt-5 mb-1">New to FleetConnect?</div>
  <button class="btn btn-orange-outline btn-block" routerLink="/access/register/reg" type="submit">Get Started</button><br>
  <a routerLink="/privacy-policy" target="_blank" style="text-decoration: none; color: inherit;">
    Terms & Conditions
  </a>
</form>
